/**
 * Star toggle for Platform Report favourites. Used on hub rows and beside
 * report view titles. Backed by `usePlatformReportFavourites` (optimistic).
 */
import { IconButton, Tooltip } from '@mui/material'
import { Star, StarBorder } from '@mui/icons-material'
import { usePlatformReportFavourites } from './PlatformReportFavourites'

interface FavouriteStarProps {
  id: string
  /** Optional override for the add tooltip, e.g. naming a specific exception. */
  label?: string
  size?: 'small' | 'medium'
}

export default function FavouriteStar({ id, label, size = 'small' }: FavouriteStarProps) {
  const { isFavourite, toggle } = usePlatformReportFavourites()
  const active = isFavourite(id)
  const addLabel = label ? `Add ${label} to favourites` : 'Add to favourites'
  const tooltip = active ? 'Remove from favourites' : addLabel

  return (
    <Tooltip title={tooltip}>
      <IconButton
        size={size}
        aria-label={tooltip}
        onClick={(e) => {
          // Keep the surrounding row <Link> from navigating.
          e.preventDefault()
          e.stopPropagation()
          toggle(id)
        }}
        sx={{ color: active ? 'warning.main' : 'action.active', flexShrink: 0 }}
      >
        {active ? <Star fontSize={size} /> : <StarBorder fontSize={size} />}
      </IconButton>
    </Tooltip>
  )
}
